import {
  GET_TCPA_HISTORY
} from './mutationTypes';
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

export default {
  [GET_TCPA_HISTORY](state, tcpaHistory) {
    state.tcpaHistory = tcpaHistory;
  },
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};